import { Injectable } from '@angular/core';
import { ApiRequestService } from '@core/auth/api-request.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, Observable, of, switchMap, tap } from 'rxjs';
import { MenuPanel, SideMenu } from './sidebar.types';
import { Bank } from '@page/connect-bank-account/helper/connect-bank-types';
import _ from 'lodash';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';
import { StorageService } from '@shared/storage.service';
import { UserService } from '@core/auth/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _menuPanel: BehaviorSubject<MenuPanel | null> = new BehaviorSubject<MenuPanel | null>(null);
  bankId: any = '';
  set menuPanel(v: MenuPanel) {
    this._menuPanel.next(v);
  }

  get menuPanel(): MenuPanel {
    return this._menuPanel.getValue() as MenuPanel
  }

  get menuPanel$(): Observable<MenuPanel | null> {
    return this._menuPanel.asObservable();
  }

  getMenuItem(id: string) {

    return _.find(this.menuPanel.sideMenu, { id });


  }

  constructor(
    private _ApiRequestService: ApiRequestService,
    private _ConnectBankService: ConnectBankService,
    private _StorageService: StorageService,
    private _UserService: UserService

  ) {
    if (this._StorageService.hasKey('menuPanel')) {
      this.menuPanel = this._StorageService.getItem('menuPanel');
    }
    if (this._StorageService.hasKey('bankId')) {
      this.bankId = this._StorageService.getItem('bankId');
    }
  }


  getMenu(bank_id: string = '', bankDtl?: Bank): Observable<any> {

    if (this.menuPanel && this.bankId == bank_id) {
      return of(this.menuPanel).pipe(tap(() => {
        this.menuPanel = this.menuPanel;
      }));
    }
    this.bankId = bank_id;
    const formData = new FormData();
    formData.append('id', bank_id);
    return this._ApiRequestService.postData(config.sidemenu.live, formData).pipe(
      switchMap((r: any) => {
        if (r.code == 200) {

          if (bankDtl) {
            const fn = (url: string) => `/${bankDtl.name}/${url}`;
            (r.data as SideMenu[]).forEach((e: SideMenu) => {
              if (e.id == 'home') {
                // e.title = 'Home'
              } else
                if (e.type == 'item') {
                  e.url = e.externalLink ? e.url : fn(e.url as string);
                  if (e.id === 'Reports') {
                    e.url = `/${bankDtl.name}/dynamic-report`;
                  }
                } else if (e.type === 'group') {
                  (e.children as SideMenu[]).forEach((d: SideMenu) => {
                    d.url = fn(d.url as string);
                  })
                }
            });
            this._ConnectBankService.isBankModuleActive = bankDtl.name;
          }
          if (!this._UserService.loginData.details.is_ticket) {
            r.data = r.data.filter((item: any) => item.name !== "Ticket");
          }
          this.menuPanel = {
            label_image: r?.label_image ?? '',
            sideMenu: r.data,
          }

          this._StorageService.setItem('menuPanel', this.menuPanel);
        } else {
          r = false;
        }
        return of(r);
      })
    );
  }
}
